import { createAction } from "@reduxjs/toolkit";
import type { ToggleBatchPublicVisibilityBody } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const toggleBatchPublicVisibility = createApiThunk<void, ToggleBatchPublicVisibilityBody>(
  "batches/toggleBatchPublicVisibility",
  async (body: ToggleBatchPublicVisibilityBody, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.toggleBatchPublicVisibility(body);
  },
);

export const resetToggleBatchPublicVisibility = createAction("batches/resetToggleBatchPublicVisibility");
